import { Box, Flex, Grid, Heading, Spinner, Text } from '@chakra-ui/react'
import { useParams, useNavigate } from 'react-router'
import { useEventDetails } from '@/hooks/events/useEventDetails'
import { useAgendaDetails } from '@/hooks/agendas/useAgendaDetails'
import { AGENDA_PERMISSIONS, hasPermission } from '@/utils/agendaPermissions'
import BackButton from '@/components/BackButton'
import GeneralSection from './components/GeneralSection'
import AddressSection from './components/AddressSection'
import RemindersSection from './components/RemindersSection'
import FinancialSection from './components/FinancialSection'
import DeleteEventButton from './components/DeleteEventButton'

const EventDetails = () => {
  const { agendaId, eventId } = useParams<{ agendaId: string; eventId: string }>()
  const navigate = useNavigate()

  const { data: event, isLoading } = useEventDetails(agendaId!, eventId!)
  const { data: agenda } = useAgendaDetails(agendaId!)

  const permissions = agenda?.permissions ?? []
  const canEditEvents = hasPermission(permissions, AGENDA_PERMISSIONS.EDIT_EVENTS)
  const canEditNotes = hasPermission(permissions, AGENDA_PERMISSIONS.EDIT_NOTES)
  const canViewFinancial = hasPermission(permissions, AGENDA_PERMISSIONS.VIEW_FINANCIAL)
  const canEditFinancial = hasPermission(permissions, AGENDA_PERMISSIONS.EDIT_FINANCIAL)

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" py={8}>
        <Spinner size="lg" color="primary.500" />
      </Box>
    )
  }

  if (!event) {
    return <Text color="fg.muted">Evento não encontrado.</Text>
  }

  return (
    <Box>
      <Flex align="center" gap={3} mb={6}>
        <BackButton />
        <Heading size="md">{event.name}</Heading>
        {canEditEvents && (
          <Box ml="auto">
            <DeleteEventButton
              agendaId={agendaId!}
              eventId={eventId!}
              onSuccess={() => navigate(`/painel/agendas/${agendaId}`, { replace: true })}
            />
          </Box>
        )}
      </Flex>

      <Flex direction="column" gap={4}>
        <Grid templateColumns={{ base: '1fr', lg: '1fr 1fr' }} gap={4} alignItems="start">
          <GeneralSection event={event} agendaId={agendaId!} canEditEvents={canEditEvents} canEditNotes={canEditNotes} />
          <AddressSection event={event} agendaId={agendaId!} eventId={eventId!} canManageEvents={canEditEvents} />
        </Grid>

        <RemindersSection event={event} agendaId={agendaId!} eventId={eventId!} canManageEvents={canEditEvents} />

        {canViewFinancial && (
          <FinancialSection event={event} agendaId={agendaId!} eventId={eventId!} canEditFinancial={canEditFinancial} />
        )}
      </Flex>

    </Box>
  )
}

export default EventDetails
